import { Component, ViewChild, ViewContainerRef, OnInit } from '@angular/core';
import { VoiceLoadService } from './voice-load.service';

import { NgModule } from '@angular/core';
import { SmallLazyLoadingService } from '../services/small-lazy-loading.service';
import { AppService, App } from '../services/app.service';
import { StorageService } from '../services/storage.service';
import { LazyLoadingService } from '../services/lazy-loading.service';


@Component({
  selector: 'app-voice-selection',
  templateUrl: './voice-selection.component.html',
  styleUrls: ['./voice-selection.component.scss']
})
export class VoiceSelectionComponent implements OnInit {
  @ViewChild('mainContainer', { read: ViewContainerRef, static: true }) mainContainerRef: any;
  actionButtonText: string;

  appName = AppService.appName;
  appBrowser = AppService.appBrowser;
  app = App;

  pwBtnText = 'go to A.I. TEXT TO SPEECH'

  constructor(private smallLazyLoadingService: SmallLazyLoadingService,
    private voiceLoader: VoiceLoadService,
    private storageService: StorageService,
    private lazyLoadingService: LazyLoadingService,) {
    this.actionButtonText = 'Next';
  }

  ngOnInit(): void {
    this.lazyLoadingService.loadFonts();
    this.voiceLoader.setupVoices();
  }

  public lazyLoadMainComponent() {
    this.voiceLoader.stopPlayingAudio();
    this.actionButtonText = 'Loading';
    document.getElementById("pw-load-close").classList.add("pw-scv-hidden");
    const selectedVoice = this.voiceLoader.selectedVoice ? this.voiceLoader.selectedVoice : 'Adam en-US plus ms 235';
    this.voiceLoader.write('pw-plusVoice', selectedVoice);
    this.voiceLoader.write('pw-voiceType', 'plus');
    this.smallLazyLoadingService.loadMainModule()
      .then(res => {
        console.log('loadMainModule res ', res)
        this.removeVoiceSelectionNode();
      });
  }

  public changePwBtnText(){
    this.pwBtnText = 'Loading...'
  }

  goToComm(){
    window.location.replace('../commercial');
  }

  public nextButtonOnClick() {
    if (this.appName == App.pw && this.appBrowser == 'webBrowser') {
      this.voiceLoader.stopPlayingAudio();
      document.getElementById("pw-voice-page").classList.add("pw-scv-hidden");
      document.getElementById("pw-comm-info").classList.remove("pw-scv-hidden");
    } else {
      this.lazyLoadMainComponent();
    }
  }

  chooseUseage(id: string) {
    const cards = document.getElementById("pw-comm-switch").querySelectorAll('.comm-switch-card');
    for (let index = 0; index < cards.length; index++) {
      const element = cards[index];
      element.classList.remove('selected');
    }
    document.getElementById(id).classList.add('selected');
  }

  private removeVoiceSelectionNode() {
    const voiceElement = document.querySelector("app-voice-selection")
    if (voiceElement != null) {
      voiceElement.parentNode.removeChild(voiceElement);
    }
  }

}

@NgModule({
  declarations: [
    VoiceSelectionComponent
  ]
})
export class VoiceSelectionModule {
  getComponent() {
    return VoiceSelectionComponent;
  }
}